/**
 * @description Basic input modal types using to show proper modal
 * */

export const modalType = {
  ETUI_CARD: 'ETUI_CARD',
  ENVELOPE_CARD: 'ENVELOPE_CARD',
  ETUI_COUPON: 'ETUI_COUPON',
  ENVELOPE_COUPON: 'ENVELOPE_COUPON',
  ENVELOPE_COUPON_PUT_IN: 'ENVELOPE_COUPON_PUT_IN',
  ENVELOPE_COUPON_PERSONALISATION: 'ENVELOPE_COUPON_PERSONALISATION',
  NDE_ETUI_CARD: 'NDE_ETUI_CARD',
  NDE_ETUI_CARD_CHRISTMAS: 'NDE_ETUI_CARD_CHRISTMAS',
  NDE_ETUI_CARD_PUT_IN: 'NDE_ETUI_CARD_PUT_IN',
  NDE_ETUI_CARD_PERSONALISATION: 'NDE_ETUI_CARD_PERSONALISATION',
  NDE_ENVELOPE_CARD_PERSONALISATION: 'NDE_ENVELOPE_CARD_PERSONALISATION',
  NDE_PROMO_PACKET: 'NDE_PROMO_PACKET',
  NDE_APP_CONFECTION: 'NDE_APP_CONFECTION',
  DEFAULT: 'DEFAULT',
};
